export default {
    url: '/schedule?dataSaved',
    template: `
        <courses-courses-edit-occurrence-edit-schedule
            course="vm.course"
            occurrence="vm.$scope.$parent.vm.occurrence"
            occurrence-trainings="vm.occurrenceTrainings"
            trainers="vm.trainers"
            rooms="vm.rooms"
            participants="vm.participants"
            training-companies="vm.trainingCompanies"
            training-times-with-participants="vm.trainingTimesWithParticipants"
            course-version="vm.courseVersion"
        />
    `,
    resolve: {
        occurrenceTrainings (OccurrenceResource, $stateParams) {
            return OccurrenceResource.getTrainings({ id: $stateParams.occurrenceId }).$promise;
        },
        participants (OccurrenceResource, $stateParams) {
            return OccurrenceResource.getParticipants(
                {
                    pageSize: 0,
                    sort: 'name',
                    privilegesCheck: 0
                },
                { occurrenceId: $stateParams.occurrenceId }
            ).$promise;
        },
        trainingCompanies (TrainingCompanyResource) {
            return TrainingCompanyResource.query({ pageSize: 0 }).$promise;
        },
        trainers (UserResource, ROLE_CODE_ENUM) {
            return UserResource.query({ roleCode: ROLE_CODE_ENUM.KEYS.TRAINER, pageSize: 0, privilegesCheck: 0 }).$promise;
        },
        courseVersion (CourseVersionResource, occurrence) {
            return CourseVersionResource.get({ id: occurrence.courseVersionId, expand: 'courseTrainings' }).$promise;
        }
    },
    controller ($scope, trainers, occurrenceTrainings,
                participants, trainingTimesWithParticipants, trainingCompanies, courseVersion) {
        this.$scope = $scope;
        this.trainers = trainers;
        $scope.$parent.vm.step = 3;
        this.course = $scope.$parent.vm.course;
        this.trainingCompanies = trainingCompanies;
        this.rooms = $scope.$parent.vm.rooms;
        this.occurrenceTrainings = occurrenceTrainings;
        this.participants = participants;
        this.trainingTimesWithParticipants = trainingTimesWithParticipants;
        this.courseVersion = courseVersion;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/edit/schedule/index.js